import { useState } from "react";
import { Check, PencilLine, X } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export default function ApprovalBar({ endpoint, onDone }) {
  const [mode, setMode] = useState(null);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const act = async (action) => {
    setBusy(true);
    try {
      await api.post(endpoint, { action, comment });
      toast.success(action === "accept" ? "Confirmed" : action === "reject" ? "Rejected" : "Edit requested");
      setMode(null);
      setComment("");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="hd-card border-amber-300 bg-amber-50/60" data-testid="approval-bar">
      <div className="text-sm font-semibold text-amber-800 mb-3">This needs your confirmation</div>
      <div className="grid grid-cols-3 gap-2">
        <button className="hd-btn-primary h-11 text-sm px-2" disabled={busy} onClick={() => act("accept")} data-testid="approval-accept-button"><Check size={16} /> Accept</button>
        <button className="hd-btn-outline h-11 text-sm px-2" disabled={busy} onClick={() => setMode("request_edit")} data-testid="approval-request-edit-button"><PencilLine size={16} /> Edit</button>
        <button className="hd-btn-outline h-11 text-sm px-2 text-red-700" disabled={busy} onClick={() => setMode("reject")} data-testid="approval-reject-button"><X size={16} /> Reject</button>
      </div>
      <Dialog open={!!mode} onOpenChange={(o) => !o && setMode(null)}>
        <DialogContent className="max-w-[420px] rounded-2xl" data-testid="approval-dialog">
          <DialogHeader><DialogTitle>{mode === "reject" ? "Reject this entry" : "Request an edit"}</DialogTitle></DialogHeader>
          <textarea data-testid="approval-comment-input" className="hd-input h-28 py-3" placeholder="Explain what needs to change…" value={comment} onChange={(e) => setComment(e.target.value)} />
          <button className="hd-btn-primary w-full" disabled={busy || !comment.trim()} onClick={() => act(mode)} data-testid="approval-dialog-submit">
            {mode === "reject" ? "Reject" : "Send request"}
          </button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
